export default {
    queryType: {
        "tyrePressureFuncQuery": "胎压功能查询",
        "codingQuery": "编程设码查询",
        "refreshHideQuery": "刷隐藏查询"
    },
    product: {
        "H6ProMaster_EN": "H6 Pro Master",
    },
    lang: {
        "CN": "中文简体",
        "TW": "中文繁体",
        "EN": "英文",
    },
    malLang: {
        "CN": "CN",
        "EN": "EN",
        "ES": "ES",
        "DE": "DE",
        "JP": "JP",
        "NL": "NL",
        "NO": "NO",
        "PL": "PL",
        "TH": "TH",
        "TR": "TR",
        "RU": "RU",
        "ID": "ID",
        "FR": "FR",
        "FA": "FA",
        "KR": "KR",
        "PT": "PT",
        "AR": "AR",
        "IT": "IT",
        "Soumi": "Soumi",
        "TW": "TW",
    }
}